// extracted by mini-css-extract-plugin
export default {"wrapper":"EndCreating_wrapper__Qsvyi","content":"EndCreating_content__2ei+5","text":"EndCreating_text__47fzb","containerButton":"EndCreating_containerButton__C3PUu"};